import { render, staticRenderFns } from "./SbolLinkText.vue?vue&type=template&id=184ae460&scoped=true&"
import script from "./SbolLinkText.vue?vue&type=script&lang=js&"
export * from "./SbolLinkText.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "184ae460",
  null
  ,true
)

export default component.exports